import { localizeOfferContract } from "features/localization/localizeService";
import { ContractType } from "./contract";

export enum OfferTypeEnum {
    Cash = 1,
    Hta = 2,
    FixBasisOnHta = 3,
    FixFuturesOnBasis = 4,
    BasisContract = 5,
    DelayedPriceContract = 6,
    CashMinPrice = 7,
    HtaMinPrice = 8,
    BasisOffer = 9,
    BushelOnlyContract = 10
}

export const AllOfferTypeEnums: OfferTypeEnum[] = [
    OfferTypeEnum.Cash,
    OfferTypeEnum.CashMinPrice,
    OfferTypeEnum.Hta,
    OfferTypeEnum.HtaMinPrice,
    OfferTypeEnum.BasisContract,
    OfferTypeEnum.DelayedPriceContract,
    OfferTypeEnum.BushelOnlyContract
]

export function getOfferTypeName(offerType: OfferTypeEnum): string {
    switch (offerType) {
        case OfferTypeEnum.Cash:
            return localizeOfferContract("OfferType_Cash");
        case OfferTypeEnum.Hta:
            return localizeOfferContract("OfferType_Hta");
        case OfferTypeEnum.BasisContract:
            return localizeOfferContract("OfferType_BasisContract");
        case OfferTypeEnum.BasisOffer:
            return localizeOfferContract("OfferType_BasisOffer");
        case OfferTypeEnum.FixFuturesOnBasis:
            return localizeOfferContract("OfferType_SetFutures");
        case OfferTypeEnum.FixBasisOnHta:
            return localizeOfferContract("OfferType_SetBasis");
        case OfferTypeEnum.DelayedPriceContract:
            return localizeOfferContract("OfferType_DelayedPriceContract");
        case OfferTypeEnum.CashMinPrice:
            return localizeOfferContract("OfferType_CashMinPrice");
        case OfferTypeEnum.HtaMinPrice:
            return localizeOfferContract("OfferType_HtaMinPrice");
        case OfferTypeEnum.BushelOnlyContract:
            return localizeOfferContract("OfferType_BushelOnlyContract");
        default:
            return "???";
    }
}

export function getOfferTypeShortName(offerType: OfferTypeEnum): string {
    switch (offerType) {
        case OfferTypeEnum.BasisOffer:
            return localizeOfferContract("OfferType_Basis");
        default:
            return getOfferTypeName(offerType);
    }
}

export function getMobileOfferTypeName(offerType: OfferTypeEnum): string {
    switch (offerType) {
        case OfferTypeEnum.Cash:
        case OfferTypeEnum.CashMinPrice:
            return "C";
        case OfferTypeEnum.Hta:
        case OfferTypeEnum.HtaMinPrice:
            return "H";
        case OfferTypeEnum.BasisContract:
        case OfferTypeEnum.BasisOffer:
            return "B";
        case OfferTypeEnum.FixFuturesOnBasis:
            return "SF";
        case OfferTypeEnum.FixBasisOnHta:
            return "SB";
        case OfferTypeEnum.DelayedPriceContract:
            return "DP";
        case OfferTypeEnum.BushelOnlyContract:
            return "BO";
        default:
            return "???";
    }
}

export function fromContractType(contractType: ContractType): OfferTypeEnum {
    switch (contractType) {
        case ContractType.Cash:
            return OfferTypeEnum.Cash;
        case ContractType.Basis:
            return OfferTypeEnum.BasisContract;
        case ContractType.Hta:
            return OfferTypeEnum.Hta;
        case ContractType.DelayedPrice:
            return OfferTypeEnum.DelayedPriceContract;
        case ContractType.CashMinPrice:
            return OfferTypeEnum.CashMinPrice;
        case ContractType.HtaMinPrice:
            return OfferTypeEnum.HtaMinPrice;
        case ContractType.BushelOnly:
            return OfferTypeEnum.BushelOnlyContract;
        default:
            throw new Error(`Unrecognized contract type ${contractType}`);
    }
}

export function toContractType(offerType: OfferTypeEnum): ContractType {
    switch (offerType) {
        case OfferTypeEnum.Cash:
        case OfferTypeEnum.FixBasisOnHta:
        case OfferTypeEnum.FixFuturesOnBasis:
            return ContractType.Cash;
        case OfferTypeEnum.Hta:
            return ContractType.Hta;
        case OfferTypeEnum.BasisContract:
        case OfferTypeEnum.BasisOffer:
            return ContractType.Basis;
        case OfferTypeEnum.DelayedPriceContract:
            return ContractType.DelayedPrice;
        case OfferTypeEnum.CashMinPrice:
            return ContractType.CashMinPrice;
        case OfferTypeEnum.HtaMinPrice:
            return ContractType.HtaMinPrice;
        case OfferTypeEnum.BushelOnlyContract:
            return ContractType.BushelOnly;
        default:
            throw new Error(`Unrecognized offer type ${offerType}`);
    }
}

export function toContractTypeWithoutPricings(offerType: OfferTypeEnum): ContractType {
    if ([OfferTypeEnum.FixBasisOnHta, OfferTypeEnum.FixFuturesOnBasis].includes(offerType)) return null;

    return toContractType(offerType);
}

export default interface OfferType {
    id: number;
    name: string;
}
